export default "__VITE_ASSET__Dj1fljtE__"